import LegalDocument, { LegalSection, OwnershipNotice } from "../components/LegalDocument";

export default function Privacy() {
  return (
    <LegalDocument
      titleEn="Privacy Policy"
      titleAr="سياسة الخصوصية"
      descriptionEn="This policy explains how information is handled when you use the app."
      descriptionAr="توضح هذه السياسة كيفية التعامل مع المعلومات عند استخدام التطبيق."
    >
      <LegalSection titleEn="1. Information Used" titleAr="1. المعلومات المستخدمة">
        {{
          childrenEn: (
            <p>
              Depending on how you use the app, information may include your name, email
              for account access, weight, food tracking entries, preferences, and reminder
              information you choose to enter.
            </p>
          ),
          childrenAr: (
            <p>
              بحسب طريقة استخدامك للتطبيق، قد تشمل المعلومات اسمك وبريدك الإلكتروني
              للوصول إلى الحساب ووزنك ومدخلات تتبع الطعام وتفضيلاتك ومعلومات التذكير
              التي تختار إدخالها.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="2. Registered Users" titleAr="2. المستخدمون المسجلون">
        {{
          childrenEn: (
            <p>
              For registered users, authentication and related profile and food log data
              are used to provide the account-based tracking features of Dialysis Diet Pro.
            </p>
          ),
          childrenAr: (
            <p>
              بالنسبة إلى المستخدمين المسجلين، تستخدم المصادقة وبيانات الملف الشخصي
              وسجل الطعام المرتبطة بها لتقديم ميزات التتبع المعتمدة على الحساب في
              Dialysis Diet Pro.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="3. Guest Mode" titleAr="3. وضع الضيف">
        {{
          childrenEn: (
            <p>
              Guest Mode does not require an email address or password. Guest profile and
              tracking entries are stored locally in the browser on the device used and may
              be removed when guest data is cleared or browser storage is cleared.
            </p>
          ),
          childrenAr: (
            <p>
              لا يتطلب وضع الضيف بريدا إلكترونيا أو كلمة مرور. تحفظ بيانات ملف الضيف
              ومدخلات التتبع محليا في المتصفح على الجهاز المستخدم، وقد تحذف عند مسح
              بيانات الضيف أو مساحة تخزين المتصفح.
            </p>
          ),
        }}
      </LegalSection>

      <LegalSection titleEn="4. Privacy and Care" titleAr="4. الخصوصية والعناية">
        {{
          childrenEn: (
            <p>
              Use the app only for information you are comfortable entering. Keep account
              credentials private. The app is a tracking tool and should not be used as a
              substitute for confidential medical consultation with your care team.
            </p>
          ),
          childrenAr: (
            <p>
              استخدم التطبيق فقط للمعلومات التي تقبل إدخالها. حافظ على سرية بيانات
              الدخول إلى حسابك. التطبيق أداة للتتبع ولا ينبغي استخدامه بديلا عن
              الاستشارة الطبية السرية مع فريق الرعاية الخاص بك.
            </p>
          ),
        }}
      </LegalSection>

      <OwnershipNotice />
    </LegalDocument>
  );
}
